import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/builds/prizmdoc/accusoft-pdf-viewer/nostromo/docs-site/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This guide explains how to configure the viewer UI to include only the features you want.`}</p>
    <h2>{`Prerequisites`}</h2>
    <p>{`Configuring the UI requires a `}<a parentName="p" {...{
        "href": "https://www.accusoft.com/products/pdf-collection/accusoft-pdf-viewer/#purchase",
        "target": "_blank",
        "rel": "noreferrer"
      }}>{`Professional`}</a>{` license. You can evaluate Professional features by setting `}<inlineCode parentName="p">{`licenseKey`}</inlineCode>{` to `}<inlineCode parentName="p">{`'eval'`}</inlineCode>{` when creating the viewer.`}</p>
    <h2>{`Directions`}</h2>
    <p>{`To configure the UI, `}<strong parentName="p">{`use the `}<inlineCode parentName="strong">{`allowedControls`}</inlineCode>{` option when calling `}<a parentName="strong" {...{
          "href": "/accusoft-pdf-viewer/latest/api/classes/pdfviewercontrol.html#create"
        }}><inlineCode parentName="a">{`create`}</inlineCode></a></strong>{`:`}</p>
    <pre {...{
      "className": "grvsc-container grvsc-has-line-highlighting default-dark",
      "data-language": "js",
      "data-index": "0"
    }}><code parentName="pre" {...{
        "className": "grvsc-code"
      }}><span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`(`}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`async`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` () `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`=>`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`  `}</span><span parentName="span" {...{
              "className": "mtk3"
            }}>{`// Create the viewer`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`  `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`window`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`.`}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`myViewer`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` = `}</span><span parentName="span" {...{
              "className": "mtk15"
            }}>{`await`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`PdfViewerControl`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`.`}</span><span parentName="span" {...{
              "className": "mtk11"
            }}>{`create`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`({`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`container:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`document`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`.`}</span><span parentName="span" {...{
              "className": "mtk11"
            }}>{`getElementById`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`(`}</span><span parentName="span" {...{
              "className": "mtk8"
            }}>{`'myContainer'`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`),`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "mtk3"
            }}>{`// URL or Uint8Array for a PDF`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`sourceDocument:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`YOUR_SOURCE_DOCUMENT`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "mtk3"
            }}>{`// Use a Professional license key or the value 'eval'`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`licenseKey`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`: `}</span><span parentName="span" {...{
              "className": "mtk8"
            }}>{`'YOUR_LICENSE_KEY'`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "mtk3"
            }}>{`// Specify the UI controls to include or exclude`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`allowedControls:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk3"
            }}>{`// These are included by default; you can remove by setting to \`false\``}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`fullScreenToggle:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`nextAndPreviousPageButtons:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`pageNumberAndCount:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`printing:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`search:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`thumbnails:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`zoomInAndOutButtons:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk3"
            }}>{`// These are removed by default; you can include by setting to \`true\``}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`ellipseTool:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`false`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`freehandDrawingTool:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`false`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`freehandSignatureTool:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`false`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`lineTool:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`false`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`rectangleTool:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`false`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "mtk12"
            }}>{`textHighlightTool:`}</span><span parentName="span" {...{
              "className": "mtk1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "mtk4"
            }}>{`false`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line grvsc-line-highlighted"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`    }`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`  });`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "mtk1"
            }}>{`})();`}</span></span></span></code></pre>
    <p>{`For more information about what each of these options mean, see the `}<a parentName="p" {...{
        "href": "/accusoft-pdf-viewer/latest/api/classes/pdfviewercontrol.html#create"
      }}>{`API reference for `}<inlineCode parentName="a">{`create`}</inlineCode></a>{`.`}</p>
    <h2>{`Examples`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Disable printing and full screen mode:`}</p>
        <pre parentName="li" {...{
          "className": "grvsc-container grvsc-has-line-highlighting default-dark",
          "data-language": "js",
          "data-index": "1"
        }}><code parentName="pre" {...{
            "className": "grvsc-code"
          }}><span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`(`}</span><span parentName="span" {...{
                  "className": "mtk4"
                }}>{`async`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` () `}</span><span parentName="span" {...{
                  "className": "mtk4"
                }}>{`=>`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`  `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`window`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`.`}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`myViewer`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` = `}</span><span parentName="span" {...{
                  "className": "mtk15"
                }}>{`await`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`PdfViewerControl`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`.`}</span><span parentName="span" {...{
                  "className": "mtk11"
                }}>{`create`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`({`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`container:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`document`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`.`}</span><span parentName="span" {...{
                  "className": "mtk11"
                }}>{`getElementById`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`(`}</span><span parentName="span" {...{
                  "className": "mtk8"
                }}>{`'myContainer'`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`),`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`sourceDocument:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`YOUR_SOURCE_DOCUMENT`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`licenseKey`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`: `}</span><span parentName="span" {...{
                  "className": "mtk8"
                }}>{`'YOUR_LICENSE_KEY'`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`, `}</span><span parentName="span" {...{
                  "className": "mtk3"
                }}>{`// or 'eval'`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`allowedControls:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`      `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`printing:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk4"
                }}>{`false`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`      `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`fullScreenToggle:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk4"
                }}>{`false`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    }`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`  });`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`})();`}</span></span></span></code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Adding the line tool and removing search:`}</p>
        <pre parentName="li" {...{
          "className": "grvsc-container grvsc-has-line-highlighting default-dark",
          "data-language": "js",
          "data-index": "2"
        }}><code parentName="pre" {...{
            "className": "grvsc-code"
          }}><span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`(`}</span><span parentName="span" {...{
                  "className": "mtk4"
                }}>{`async`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` () `}</span><span parentName="span" {...{
                  "className": "mtk4"
                }}>{`=>`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`  `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`window`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`.`}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`myViewer`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` = `}</span><span parentName="span" {...{
                  "className": "mtk15"
                }}>{`await`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`PdfViewerControl`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`.`}</span><span parentName="span" {...{
                  "className": "mtk11"
                }}>{`create`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`({`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`container:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`document`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`.`}</span><span parentName="span" {...{
                  "className": "mtk11"
                }}>{`getElementById`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`(`}</span><span parentName="span" {...{
                  "className": "mtk8"
                }}>{`'myContainer'`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`),`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`sourceDocument:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`YOUR_SOURCE_DOCUMENT`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`licenseKey`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`: `}</span><span parentName="span" {...{
                  "className": "mtk8"
                }}>{`'YOUR_LICENSE_KEY'`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`, `}</span><span parentName="span" {...{
                  "className": "mtk3"
                }}>{`// or 'eval'`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`allowedControls:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` {`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`      `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`lineTool:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk4"
                }}>{`true`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`      `}</span><span parentName="span" {...{
                  "className": "mtk12"
                }}>{`search:`}</span><span parentName="span" {...{
                  "className": "mtk1"
                }}>{` `}</span><span parentName="span" {...{
                  "className": "mtk4"
                }}>{`false`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line grvsc-line-highlighted"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`    }`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`  });`}</span></span></span>{`
`}<span parentName="code" {...{
              "className": "grvsc-line"
            }}><span parentName="span" {...{
                "className": "grvsc-source"
              }}><span parentName="span" {...{
                  "className": "mtk1"
                }}>{`})();`}</span></span></span></code></pre>
      </li>
    </ul>
    <h2>{`Related`}</h2>
    <ul>
      <li parentName="ul">{`How to `}<a parentName="li" {...{
          "href": "/accusoft-pdf-viewer/latest/how-to/enable-annotation-tools/"
        }}>{`enable annotation tools`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/accusoft-pdf-viewer/latest/api/classes/pdfviewercontrol.html#create"
        }}>{`API Reference for `}<inlineCode parentName="a">{`create`}</inlineCode></a></li>
    </ul>

    <style {...{
      "className": "grvsc-styles"
    }}>{`
  .grvsc-container {
    overflow: auto;
    position: relative;
    -webkit-overflow-scrolling: touch;
    padding-top: 1rem;
    padding-top: var(--grvsc-padding-top, var(--grvsc-padding-v, 1rem));
    padding-bottom: 1rem;
    padding-bottom: var(--grvsc-padding-bottom, var(--grvsc-padding-v, 1rem));
    border-radius: 8px;
    border-radius: var(--grvsc-border-radius, 8px);
    font-feature-settings: normal;
    line-height: 1.4;
  }
  
  .grvsc-code {
    display: table;
  }
  
  .grvsc-line {
    display: table-row;
    box-sizing: border-box;
    width: 100%;
    position: relative;
  }
  
  .grvsc-line > * {
    position: relative;
  }
  
  .grvsc-gutter-pad {
    display: table-cell;
    padding-left: 0.75rem;
    padding-left: calc(var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem)) / 2);
  }
  
  .grvsc-gutter {
    display: table-cell;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  
  .grvsc-gutter::before {
    content: attr(data-content);
  }
  
  .grvsc-source {
    display: table-cell;
    padding-left: 1.5rem;
    padding-left: var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem));
    padding-right: 1.5rem;
    padding-right: var(--grvsc-padding-right, var(--grvsc-padding-h, 1.5rem));
  }
  
  .grvsc-source:empty::after {
    content: ' ';
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  
  .grvsc-gutter + .grvsc-source {
    padding-left: 0.75rem;
    padding-left: calc(var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem)) / 2);
  }
  
  /* Line transformer styles */
  
  .grvsc-has-line-highlighting > .grvsc-code > .grvsc-line::before {
    content: ' ';
    position: absolute;
    width: 100%;
  }
  
  .grvsc-line-diff-add::before {
    background-color: var(--grvsc-line-diff-add-background-color, rgba(0, 255, 60, 0.2));
  }
  
  .grvsc-line-diff-del::before {
    background-color: var(--grvsc-line-diff-del-background-color, rgba(255, 0, 20, 0.2));
  }
  
  .grvsc-line-number {
    padding: 0 2px;
    text-align: right;
    opacity: 0.7;
  }
  
  .default-dark {
    background-color: #1E1E1E;
    color: #D4D4D4;
  }
  .default-dark .mtk1 { color: #D4D4D4; }
  .default-dark .mtk4 { color: #569CD6; }
  .default-dark .mtk3 { color: #6A9955; }
  .default-dark .mtk12 { color: #9CDCFE; }
  .default-dark .mtk15 { color: #C586C0; }
  .default-dark .mtk11 { color: #DCDCAA; }
  .default-dark .mtk8 { color: #CE9178; }
  .default-dark .grvsc-line-highlighted::before {
    background-color: var(--grvsc-line-highlighted-background-color, rgba(255, 255, 255, 0.1));
    box-shadow: inset var(--grvsc-line-highlighted-border-width, 4px) 0 0 0 var(--grvsc-line-highlighted-border-color, rgba(255, 255, 255, 0.5));
  }
`}</style>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      